<template>
  <div class="home">
    <div class="title">云打印上传助手</div>
    <div class="mask">
      上传后请在微信小程序同步若关闭了小程序，请点击重新扫码
    </div>
    <div class="lists">
      <div class="btns">
        <div class="saoma" @click="dialogVisible = true">重新扫码</div>
        <div class="upload" @click="handleUpload">上传文件</div>
      </div>
      <div class="list">
        <!-- <div v-if="fileList.length === 0" class="empty-list">
          暂无上传文件，请点击上传文件按钮
        </div> -->
        <div class="items" v-for="(item, index) in fileList" :key="index">
          <div class="file">
            <img class="file-icon" :src="getIconBySrc(item.fileName)" alt="" />
            <div class="file-tlt">{{ item.fileName }}</div>
          </div>
          <div class="file-del" @click="delFile(item.id)">删除</div>
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="25%"
      :before-close="handleClose"
    >
      <div class="dialog-tlt">请用微信扫码登录</div>
      <div class="dialog-qrcode">
        <img :src="imgUrl" alt="" />
      </div>
    </el-dialog>

    <input
      type="file"
      ref="fileInput"
      style="display: none"
      @change="onFileChange"
      multiple
      accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx,.jpg,.jpeg,.png,.zip,.rar"
    />
  </div>
</template>
<script>
import {
  wxaqrcode,
  getComputerFilesList,
  getUploadPostPolicy,
  computerupload,
  computerdelete,
} from "@/api/index";

export default {
  name: "HomeView",
  data() {
    return {
      dialogVisible: false,
      imgUrl: "",
      fileList: [],
      demoToken: "",
      // 允许上传的文件格式配置
      allowedFileTypes: [
        {
          name: "Word 文档",
          extensions: ["doc", "docx"],
          description: "Microsoft Word 文档格式",
        },
        {
          name: "PDF 文档",
          extensions: ["pdf"],
          description: "PDF 便携式文档格式",
        },
        // {
        // 	name: 'Excel 表格',
        // 	extensions: ['xls', 'xlsx'],
        // 	description: 'Microsoft Excel 表格格式'
        // },
        {
          name: "PowerPoint 演示文稿",
          extensions: ["ppt", "pptx"],
          description: "Microsoft PowerPoint 演示文稿格式",
        },
        // {
        // 	name: '纯文本文档',
        // 	extensions: ['txt'],
        // 	description: '纯文本文件格式'
        // },
        // {
        // 	name: '图片文件',
        // 	extensions: ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
        // 	description: '常见图片格式'
        // }
      ],
    };
  },

  computed: {
    // 获取所有支持的文件后缀
    supportedExtensions() {
      const extensions = [];
      this.allowedFileTypes.forEach((fileType) => {
        extensions.push(...fileType.extensions);
      });
      return extensions;
    },
  },
  mounted() {},
  created() {
    // this.demoToken = this.generateRandomString(15);
    //  this.demoToken = 'PWZDtJkpiSHBiXi';
    if (localStorage.getItem("webToken")) {
      this.demoToken = localStorage.getItem("webToken");
    } else {
      this.generateRandomString();
    }
    // this.getSign();
    this.wxaqrcode();
    this.getComputerFilesList();
  },
  methods: {
    delFile(id) {
      this.$confirm("是否删除文件?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          computerdelete(this.demoToken, id).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: res.msg || "删除成功",
                duration: 20000,
                center: true,
              });
              this.getComputerFilesList();
            }
          });
        })
        .catch(() => {
          this.showDialog("已取消删除");
        });
    },
    getComputerFilesList() {
      getComputerFilesList({
        webToken: this.demoToken,
      }).then((res) => {
        console.log(res);
        this.fileList = res.data;
      });
    },
    //  上传
    // 触发文件上传
    handleUpload() {
      this.$refs.fileInput.click();
    },
    // 验证文件格式是否被支持
    isFileTypeSupported(fileExtension) {
      const ext = fileExtension.toLowerCase();
      return this.supportedExtensions.includes(ext);
    },
    // 文件选择变化
    onFileChange(e) {
      const tempFiles = e.target.files;
      if (!tempFiles.length) return;

      for (let i = 0; i < tempFiles.length; i++) {
        const file = tempFiles[i];
        const fileName = file.name;
        const fileExtension = fileName.split(".").pop().toLowerCase(); // 建议转小写

        // 格式验证
        if (!this.isFileTypeSupported(fileExtension)) {
          this.$message.error(
            `当前不支持 .${fileExtension.toUpperCase()} 格式的文件。`
          );
          continue;
        }

        // 文件大小限制（可选，例如 100MB）
        const maxSize = 100 * 1024 * 1024; // 100MB
        if (file.size > maxSize) {
          this.$message.error(`文件 ${fileName} 超出大小限制（100MB）`);
          continue;
        }

        // 生成新文件名
        const newFileName = `${this.generateRandomString2(
          15
        )}.${fileExtension}`;
        const fileSize = file.size;

        this.$message.success(
          `正在上传第 ${i + 1}/${tempFiles.length} 个文件...`
        );

        // ✅ 正确：传入 file 对象，而不是 path
        this.uploadSingleFile({
          fileName,
          fileSize,
          uploadFileName: newFileName,
          fileExtension,
          tempFile: file, // ✅ 改这里：传 file 对象
        });
      }

      // 清空 input
      e.target.value = "";
    },
    async uploadSingleFile(fileInfo) {
      const { fileName, fileSize, uploadFileName, fileExtension, tempFile } =
        fileInfo;

      // ✅ 关键：校验 tempFile 是否为 File 或 Blob
      if (!(tempFile instanceof File || tempFile instanceof Blob)) {
        this.$message.error("上传失败：文件无效，请重新选择");
        console.error("无效的文件对象:", tempFile);
        return;
      }

      try {
        const res = await getUploadPostPolicy({
          fileName: uploadFileName,
          webToken: this.demoToken,
        });

        if (res.code !== 0) {
          this.$message.error(res.msg || "获取上传地址失败");
          return;
        }

        const { configId, ossAccessKeyId, policy, signature, dir, host } =
          res.data;

        // ✅ 构造 FormData
        const formData = new FormData();
        formData.append("key", dir + uploadFileName);
        formData.append("OSSAccessKeyId", ossAccessKeyId);
        formData.append("policy", policy);
        formData.append("signature", signature);
        formData.append("success_action_status", "200");

        // ✅ 正确：使用 File 对象上传
        formData.append("file", tempFile, uploadFileName); // 第三个参数是建议的文件名

        // ✅ 使用 fetch 上传
        const response = await fetch(host, {
          method: "POST",
          body: formData,
        });

        if (!response.ok) {
          throw new Error(`上传失败，状态码: ${response.status}`);
        }

        // 通知后端记录文件
        await computerupload({
          file: {
            configId,
            url: host + "/" + dir + uploadFileName,
            path: dir + uploadFileName,
            name: fileName,
            ext: fileExtension,
            size: fileSize,
          },
          webToken: this.demoToken,
        });

        // 刷新列表
        this.getComputerFilesList();
        this.$message.success(`${fileName} 上传成功`);
      } catch (err) {
        console.error("文件上传失败:", err);
        this.$message.error(
          `${fileName} 上传失败：${err.message || "未知错误"}`
        );
      }
    },

    generateRandomString2(length) {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    },

    generateRandomString() {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      for (let i = 0; i < 15; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      // return result;
      // console.log("resultresult", result);
      localStorage.setItem("webToken", result);
    },
    wxaqrcode() {
      wxaqrcode({
        scene: this.demoToken,
        path: "pages/pcUpload/index",
      })
        .then((res) => {
          // console.log(res);
          this.imgUrl = "data:image/png;base64," + res.data;
          // console.log(this.imgUrl);
        })
        .catch((error) => {
          console.error("Error generating QR code:", error);
        });
    },
    handleClose(done) {
      done();
    },
    // 根据文件路径返回对应的图标
    getIconBySrc(src) {
      const ext = src.toLowerCase().split(".").pop();
      const iconMap = {
        png: "jpg.png",
        jpg: "jpg.png",
        jpeg: "jpg.png",
        gif: "jpg.png",
        bmp: "jpg.png",
        pdf: "pdf.png",
        doc: "word.png",
        docx: "word.png",
        ppt: "ppt.png",
        pptx: "ppt.png",
      };

      const iconFile = iconMap[ext];
      if (iconFile) {
        try {
          return require(`@/assets/image/${iconFile}`);
        } catch (err) {
          console.warn(`图标未找到: ${iconFile}`);
        }
      }
      return "/static/image/word.png"; // 默认图标（放在 public 目录）
    },
  },
};
</script>
<style>
body {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
</style>
<style scoped lang="scss">
.home {
  overflow: hidden;
  .title {
    width: 100%;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #3d3d3d;
    line-height: 21px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 80px;
  }
  .mask {
    width: 100%;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #696969;
    line-height: 21px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin-top: 10px;
  }
  .lists {
    width: 1080px;
    height: auto;
    background: #ffffff;
    border-radius: 15px 15px 15px 15px;
    padding: 54px 121px 54px 35px;
    margin: 0 auto;
    margin-top: 45px;
    .btns {
      width: auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .saoma {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #3d3d3d;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-right: 20px;
        cursor: pointer;
      }
      .upload {
        width: 89px;
        height: 36px;
        background: #ff9718;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #ff9718;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }
    }
    .list {
      width: 100%;
      height: auto;
      margin-top: 37px;
      .items {
        width: 100%;
        padding: 8px 0 8px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 7px;
        .file {
          display: flex;
          align-items: center;
          .file-icon {
            width: 37px;
            height: 37px;
            display: block;
            margin-right: 3px;
          }
          .file-tlt {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #3d3d3d;
            line-height: 21px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
        .file-del {
          width: 70px;
          height: 32px;
          background: #ffe4cb;
          border-radius: 6px 6px 6px 6px;
          border: 1px solid #ff9718;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #ff9718;
          line-height: 32px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
        }
      }
    }
  }
  .dialog-tlt {
    width: 100%;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #3d3d3d;
    line-height: 21px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .dialog-qrcode {
    width: 230px;
    height: 230px;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #e7e7e7;
    margin: 0 auto;
    margin-top: 30px;
    padding: 13px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
